import {
    GET_CASE_HISTORY_REQUEST,
    GET_CASE_HISTORY_SUCCESS,
    GET_CASE_HISTORY_FAILURE
} from './constants';

const initialState = {
    logs: null,
    loading: false,
};


/*
filterOptions: {
    historyPage: 1,
    historyLimit: globals.historyPerPage,
    notificationsPage: 1,
    notificationsLimit: globals.historyPerPage
}
*/

const historyLogsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CASE_HISTORY_REQUEST: {
            return Object.assign({}, state, {loading: true, logs: null,});
        }
        case GET_CASE_HISTORY_SUCCESS: {
            return Object.assign({}, state, {loading: false, logs: action.data});
        }
        case GET_CASE_HISTORY_FAILURE: {
            return Object.assign({}, state, {loading: false, logs: null});
        }
        default: {
            return state;
        }
    }
};

export default historyLogsReducer;



// WEBPACK FOOTER //
// ./src/containers/History/reducer.js